import type { ElementWorkCounts } from './types';

/**
 * Migawka ciepła — **wybór** widocznej siódemki zamrożony, **liczby** żywe (decyzja 172).
 *
 * ⭐⭐ Ciepło ma dwie role i tylko jedna może być żywa. Liczba w wierszu ma być świeża, ale
 * wybór, kto przechodzi przez próg zwijania (decyzja 45), musi stać — inaczej domknięcie
 * jednego zadania przestawia skład widocznej siódemki i wiersze skaczą człowiekowi pod ręką.
 * Słowo usera 2026-09-06: *„po zamknięciu zadania nie odświeżamy listy co do elementów i nie
 * przenosimy elementu niżej, bo ma teraz mniej ciepła […] dopiero kolejne odświeżenie drzewka
 * zaciągnie i posortuje listę"*.
 *
 * ⛔ Wariantu dosłownego („odejmij lokalnie i nie pytaj serwera") nie da się zrobić: domknięcie
 * **budzi albo osierocia zobowiązania na cudzych elementach** (decyzje 21–22), więc liczby
 * zmieniają się w miejscach, o których ta mutacja nic nie wie. Zamrażamy WYBÓR, nie prawdę.
 *
 * ⭐ Osobny moduł, a nie `useMemo` w ekranie, z jednego powodu: tak da się to sprawdzić
 * **deterministycznie**, bez orkiestrowania dwóch odpowiedzi HTTP i rozwinięcia gałęzi po to,
 * żeby zobaczyć jedną regułę scalania.
 */
export interface HeatSnapshotInput {
  /** Migawka z poprzedniego przeliczenia. */
  previous: ReadonlyMap<number, ElementWorkCounts>;
  /** Liczby, które właśnie przyszły — źródło nowych wpisów. */
  live: ReadonlyMap<number, ElementWorkCounts>;
  /** Czy widok się zmienił (inny korzeń, inna soczewka, inny próg) — wtedy migawka pada. */
  stale: boolean;
}

/**
 * Nowa migawka.
 *
 * - **Dokleja** wpisy dla elementów, których jeszcze nie znała — rozwinięta gałąź musi dostać
 *   swoje ciepło, inaczej jej sekcja ustawiłaby się alfabetycznie i przeskoczyła chwilę później.
 * - ⛔ **Nigdy nie nadpisuje** wpisu, który już ma — na tym stoi całe zamrożenie.
 * - **Zeruje się** przy zmianie widoku; ⚠ samo odświeżenie danych nią nie jest, bo powrót do
 *   karty nie jest powodem, żeby wiersze się przestawiły.
 *
 * ⭐ Przy braku zmian oddaje **tę samą tożsamość**, żeby przeliczenie wierszy nie ruszało przy
 * każdej odpowiedzi o liczbach — czyli dokładnie tam, gdzie zamrożenie ma działać.
 */
export function mergeHeatSnapshot({
  previous,
  live,
  stale,
}: HeatSnapshotInput): ReadonlyMap<number, ElementWorkCounts> {
  const base = stale ? new Map<number, ElementWorkCounts>() : previous;
  const missing = [...live].filter(([id]) => !base.has(id));

  if (!stale && missing.length === 0) {
    return base;
  }

  const next = new Map(base);
  for (const [id, counts] of missing) {
    next.set(id, counts);
  }

  return next;
}
